var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2882 27.7787L7.33789 23.2199L7.36227 14.1458L7.38924 5.07218M15.2882 27.7787L23.241 32.3374M15.2882 27.7787V23.8284M23.2653 13.6674L23.241 32.3374M23.2653 13.6674L25.0622 12.6314M23.2653 13.6674L20.6311 12.272M23.241 32.3374L25.0353 31.3014L25.0622 12.6314M25.0622 12.6314L20.6311 10.1667M7.38924 5.07218L9.18357 4.03567L10.9473 5.02611M7.38924 5.07218L10.9473 7.13137M18.8086 7.55144L18.7818 25.8328M18.8086 7.55144L10.8559 2.9926M18.8086 7.55144L20.6029 6.51542M18.7818 25.8328L10.8315 21.2739L10.8437 16.7369L10.8559 2.9926M18.7818 25.8328L20.5786 24.7967L20.6029 6.51542M10.8559 2.9926L12.6527 1.95703L20.6029 6.51542",
    stroke: "currentColor",
    strokeWidth: 0.484211,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};

export default __webpack_public_path__ + "static/media/application_facade.8b395490.svg";
export { SvgComponent as ReactComponent };